import { AvatarComponent } from '../../components/avatar/avatar.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, DecimalPipe } from '@angular/common';
import { LetModule, PushModule } from '@ngrx/component';
import {
  NgbAlertModule,
  NgbCarouselModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';

import { ButtonComponent } from '../../components/button/button.component';
import { SelectComponent } from '../../components/inputs/select/select.component';
import { TextareaComponent } from '../../components/inputs/textarea/textarea.component';
import { CheckboxComponent } from '../../components/inputs/checkbox/checkbox.component';
import { CategoriesComponent } from '../../components/categories/categories.component';
import { CategoryComponent } from '../../components/category/category.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoComponent } from '../../components/logo/logo.component';
import { AuthButtonComponent } from '../../components/auth-button/auth-button.component';
import { BackToHomeComponent } from './components/back-to-home/back-to-home.component';
import { HeroTitleComponent } from '../../components/hero-title/hero-title.component';
import { EventListComponent } from '../../components/event-list/event-list.component';
import { EventComponent } from '../../components/event/event.component';
import { LikeCheckboxComponent } from '../../components/inputs/like-checkbox/like-checkbox.component';
import { PopupComponent } from '../../components/popup/popup.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { MultiselectComponent } from '../../components/inputs/multiselect/multiselect.component';
import { DatepickerComponent } from '../../components/inputs/datepicker/datepicker.component';
import { CarouselFlatComponent } from '../../components/carousel-flat/carousel-flat.component';
import { OrganizationComponent } from '../../components/organization/organization.component';
import { OrganizationsComponent } from '../../components/organizations/organizations.component';
import { FollowCheckboxComponent } from '../../components/inputs/follow-checkbox/follow-checkbox.component';
import { ResultCountComponent } from '../../components/result-count/result-count.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { DateTimeComponent } from '../../components/date-time/date-time.component';
import { CategoryBadgeComponent } from '../../components/category-badge/category-badge.component';
import { LocationComponent } from '../../components/location/location.component';
import { EntityLogoComponent } from '../../components/entity-logo/entity-logo.component';
import { EventByComponent } from '../../components/event-by/event-by.component';
import { EventRegistrationComponent } from '../../components/event-registration/event-registration.component';
import { BackToEventComponent } from './components/back-to-event/back-to-event.component';
import { CollapsibleComponent } from './components/collapsible/collapsible.component';
import { KlixBannerComponent } from '../../components/klix-banner/klix-banner.component';
import { OrderSummaryComponent } from '../../components/order-summary/order-summary.component';
import { SafeUrlPipe } from './pipes/safeUrl.pipe';
import { EventRegistrationFormComponent } from '../../components/event-registration-form/event-registration-form.component';
import { EventRegistrationSuccessComponent } from '../../components/event-registration-success/event-registration-success.component';
import { EventRegistrationFailComponent } from '../../components/event-registration-fail/event-registration-fail.component';
import { TextEditorComponent } from '../../components/inputs/text-editor/text-editor.component';
import { ExpandComponent } from './components/expand/expand.component';
import { ResizeDirective } from '../../directives/resize.directive';
import { BreadcrumbsComponent } from '../../components/breadcrumbs/breadcrumbs.component';
import { SearchModule } from '../search/search.module';
import { InputModule } from '../../components/inputs/input/input.module';
import { SearchResultsComponent } from '../../pages/search-results/search-results.component';
import { ScrollToDirective } from '../../directives/scrollTo.directive';
import { ObserversModule } from '@angular/cdk/observers';
import { CollapsibleLightComponent } from './components/collapsible-light/collapsible-light.component';
import { DesktopNavigationDropdownComponent } from '../../components/desktop-navigation-dropdown/desktop-navigation-dropdown.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TelInputComponent } from '../../components/inputs/tel-input/tel-input.component';
import { BadgeModule } from '../../components/badge/badge.module';
import { IconModule } from '../../components/icon/icon.module';
import { PipeModule } from './pipes/pipe.module';
import { ImgCropComponent } from '../../components/inputs/img-crop/img-crop.component';
import { DateInputComponent } from '../../components/inputs/date-input/date-input.component';
import { TimeInputComponent } from '../../components/inputs/time-input/time-input.component';
import { RadioComponent } from '../../components/inputs/radio/radio.component';
import { MultiSelectAdvancedComponent } from '../../components/inputs/multi-select-advenced/multi-select-advanced.component';
import { LocationAutocompleteComponent } from '../../components/inputs/location-autocomplete/location-autocomplete.component';
import { AvatarInputComponent } from '../../components/inputs/avatar-input/avatar-input.component';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { DeletePopupComponent } from '../../components/popups/delete-popup/delete-popup.component';
import { OrganizationEmptyEventListComponent } from '../../components/search-result/organization-empty-event-list/organization-empty-event-list.component';
import { ContactUsFormComponent } from '../../components/contact-us-form/contact-us-form.component';
import { MessageBannerComponent } from './components/message-banner/message-banner.component';
import { UnauthorizedUserPopupComponent } from '../../components/popups/unauthorized-user-popup/unauthorized-user-popup.component';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { CONSTANTS } from '../../constants/constants';
import { MobileNavigationDropdownComponent } from '../../components/mobile-navigation-dropdown/mobile-navigation-dropdown.component';

const COMPONENTS = [
  LikeCheckboxComponent,
  SelectComponent,
  TextareaComponent,
  CheckboxComponent,
  CategoriesComponent,
  CategoryComponent,
  HeaderComponent,
  NavigationComponent,
  LogoComponent,
  AuthButtonComponent,
  BackToHomeComponent,
  HeroTitleComponent,
  EventListComponent,
  EventComponent,
  PopupComponent,
  MultiselectComponent,
  CarouselFlatComponent,
  OrganizationComponent,
  OrganizationsComponent,
  FollowCheckboxComponent,
  ResultCountComponent,
  GoogleMapComponent,
  CategoryBadgeComponent,
  DateTimeComponent,
  EventByComponent,
  EventRegistrationComponent,
  BackToEventComponent,
  CollapsibleComponent,
  CollapsibleLightComponent,
  KlixBannerComponent,
  OrderSummaryComponent,
  EventRegistrationSuccessComponent,
  EventRegistrationFormComponent,
  EventRegistrationFailComponent,
  TextEditorComponent,
  ExpandComponent,
  BreadcrumbsComponent,
  SearchResultsComponent,
  AvatarComponent,
  DesktopNavigationDropdownComponent,
  TelInputComponent,
  ImgCropComponent,
  DateInputComponent,
  TimeInputComponent,
  RadioComponent,
  MultiSelectAdvancedComponent,
  LocationAutocompleteComponent,
  AvatarInputComponent,
  DeletePopupComponent,
  OrganizationEmptyEventListComponent,
  ContactUsFormComponent,
  MessageBannerComponent,
  UnauthorizedUserPopupComponent,
  MobileNavigationDropdownComponent,
];

const MODULES = [
  AngularMultiSelectModule,
  QuillModule,
  PushModule,
  LetModule,
  NgbCarouselModule,
  NgbAlertModule,
  NgbTooltipModule,
  InputModule,
  SearchModule,
  ButtonComponent,
  DatepickerComponent,
  EntityLogoComponent,
  ResizeDirective,
  ScrollToDirective,
  LocationComponent,
  SafeUrlPipe,
  ObserversModule,
  BadgeModule,
  IconModule,
  PipeModule,
  RecaptchaModule,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule,
    NgxPopperjsModule,
    ...MODULES,
  ],
  exports: [...COMPONENTS, ...MODULES],
  providers: [
    DecimalPipe,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: CONSTANTS.RECAPTCHA.SITE_KEY,
      } as RecaptchaSettings,
    },
  ],
})
export class SharedModule {}
